import { useCallback, useEffect, useRef, useState } from "react";

import { getAbsoluteUrl } from "shared/lib/utils";

const LINK_COPIED_VISIBLE_MS = 2000;

/** Copies the article link to the clipboard and shows a "Link Copied"
 * toast for a fixed window. Re-clicking while visible resets the timer;
 * the pending timeout is cleared on unmount.
 */
export const useCopyLink = (urlAlias?: string) => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const timeoutReference = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const handleCopyLink = useCallback(() => {
    if (!urlAlias) return;
    void navigator.clipboard.writeText(getAbsoluteUrl(urlAlias));

    setIsLinkCopied(true);
    clearTimeout(timeoutReference.current);
    timeoutReference.current = setTimeout(() => {
      setIsLinkCopied(false);
    }, LINK_COPIED_VISIBLE_MS);
  }, [urlAlias]);

  useEffect(() => () => clearTimeout(timeoutReference.current), []);

  return { handleCopyLink, isLinkCopied };
};
